// extracted by css-extract-rspack-plugin
export default {"listBody":"hDigkC6Kf4I6cg24","footerRow":"ObD0u_YAmmg3EzlD"};